import {
  DefinitionActionKindEnum,
  DefinitionActionSubKindEnum,
} from '@acme/api';
import {
  ApplicationCounterpartyOfferForm,
  findAction,
  type CounterpartyOfferFormData,
} from '@acme/features';
import { BreadcrumbItem, Page } from '@acme/foundation';
import { $application } from '@entities/application';
import {
  $isSubmitting,
  counterpartyOfferRequested,
  counterpartyOfferSucceeded,
} from '@features/applicationActions';
import { actionResultShown } from '@widgets/applicationActions/model';
import { useUnit } from 'effector-react';
import { Card } from 'flowbite-react';
import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const CounterpartyOfferPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { application, onCounterpartyOfferRequested, isSubmitting } = useUnit({
    application: $application,
    onCounterpartyOfferRequested: counterpartyOfferRequested,
    isSubmitting: $isSubmitting,
  });

  const actions = application?.actions ?? null;
  const formAction = useMemo(
    () =>
      findAction(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormCounterpartyInfo
      ),
    [actions]
  );

  useEffect(() => {
    const unsub = counterpartyOfferSucceeded.watch(() => {
      actionResultShown({
        isError: false,
        actionName: formAction?.name ?? 'Отправить предложение',
        customResult: {
          title: 'Предложение отправлено!',
          linkText: 'На главную',
          link: '/dashboard',
        },
      });
    });
    return () => unsub();
  }, [formAction?.name]);

  const handleConfirm = useCallback(
    (data: CounterpartyOfferFormData) => {
      if (!formAction?.id || !id) return;

      console.log(data.files);

      const commission =
        data.commissionAuthorizedOrganizationRUB === ''
          ? 0
          : Number(data.commissionAuthorizedOrganizationRUB);
      if (!Number.isFinite(commission) || commission <= 0) return;
      onCounterpartyOfferRequested({
        actionId: formAction.id,
        sign: formAction.arguments?.sign,
        commissionAuthorizedOrganizationRUB: commission,
        files: data.files ?? [],
      });
    },
    [
      formAction?.id,
      formAction?.arguments?.sign,
      id,
      onCounterpartyOfferRequested,
    ]
  );

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Главная', onClick: () => navigate('/dashboard') },
    ...(application
      ? [
          {
            label: application.code ?? 'Заявка',
            onClick: () => navigate(`/application/${application.id}`),
          },
          { label: formAction?.name ?? 'Предложение о сделке' },
        ]
      : [{ label: 'Заявка не найдена' }]),
  ];

  return (
    <Page breadcrumbItems={breadcrumbItems}>
      <Card>
        <ApplicationCounterpartyOfferForm
          inline
          isSubmitting={isSubmitting}
          onConfirm={handleConfirm}
        />
      </Card>
    </Page>
  );
};
